<template>
  <a-card :bordered="false" title="商品列表" class="infoMain" :headStyle="{ fontSize: '18px' }">
    <search-page-view
      :col="3"
      :buttonCol="2"
      ref="pageList"
      :itemNames="searchItemList"
      :buttonItems="['download']"
      :columns="getColumns()"
      :queryParams="queryParams"
      :before-search="beforeSearchEvent"
      @export="exportEventPro"
      row-key="proId"
      :leftSpace="10"
      :requestPromise="getGoodsPromise"
      :exportType="2"
      :customPagination="true"
      extraPaginationName="extraPaginationName"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <a-form-item slot="search_proId" label="商品ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_proNo" label="商品编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proCode" placeholder="套餐编号/房型编号/计划编号等"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_proType" label="商品分类" v-bind="searchItemLayout">
        <a-select allowClear style="width: 100%" v-model="queryParams.proType" placeholder="请选择">
          <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code"
          >{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="search_proSource" label="商品来源" v-bind="searchItemLayout">
        <a-select allowClear style="width: 100%" v-model="queryParams.proSource" placeholder="请选择">
          <a-select-option v-for="item in sourceList" :key="item.code" :value="item.code"
          >{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="search_sales_volume" label="累计销量" v-bind="searchItemLayout">
        <a-input-number
          v-model="queryParams.proSaleMin"
          :min="1"
          :max="1000000"
          style="width: 45%"
          placeholder="最小值"
        />
        <div style="width: 10%;text-align: center;display: inline-block">-</div>
        <a-input-number
          style="width: 45%"
          v-model="queryParams.proSaleMax"
          :min="queryParams.proSaleMin ? queryParams.orderEndTime : 1"
          :max="1000000"
          placeholder="最大值"
        />
      </a-form-item>
      <a-form-item slot="search_date" label="创建日期" v-bind="searchItemLayout">
        <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
      </a-form-item>
      <a-button slot="download" style="margin-left: 8px" @click="handleLook">查看已生成报表</a-button>
      <a-form-item slot="operation">
        <a-radio-group v-model="pageType" defaultValue="1" :style="{ marginBottom: '8px' }" @change="onTypeChange">
          <!--全部null,在售中1,已下架0 ,-->
          <a-radio-button :value="null">全部</a-radio-button>
          <a-radio-button :value="1">在售中</a-radio-button>
          <a-radio-button :value="0">已下架</a-radio-button>
        </a-radio-group>
        <span style="margin: 0  0 0 20px;"
              v-if="$store.getters.merchantField.merchantType != 2&&categoryList&&categoryList.length">
          <a-button type="primary" v-if="categoryList&&categoryList.length>1">
            <a-dropdown>
              <a class="ant-dropdown-link">创建新商品
                <a-icon type="down"/>
              </a>
              <a-menu slot="overlay" @click="createProduct">
                <a-menu-item v-for="item in categoryList" :key="item.code">
                  <a href="javascript:">{{ item.name }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-button>
          <a-button v-else type="primary" @click="createProduct({key:categoryList[0].code})">创建新商品</a-button>
        </span>
        <a-button type="primary" style="margin: 0  0 0 20px;" @click="showCategoryModal">申请品类</a-button>
        <span style="float: right" @click="onSetting">开启低库存提醒<a>设置</a></span>
      </a-form-item>
      <template slot="info" slot-scope="rowItem">
        <div class="item-proInfo">
          <CustomImage :imageUrl="rowItem.record.proImg" :width="80" :height="80"></CustomImage>
          <div class="content-right">
            <a-tooltip placement="topLeft">
              <template slot="title">{{ rowItem.record.proName }}</template>
              <div class="pro_title">{{ rowItem.record.proName }}</div>
            </a-tooltip>
            <div class="bottom-box">
              <div class="pro_id">ID：{{ rowItem.record.proId }}</div>
              <div class="pro_tag">
                <span class="tag"
                      v-if="rowItem.record.proSource === 0 && rowItem.record.proJoinType === 22">ERP商品</span>
                <span class="tag" v-if="rowItem.record.proSource !== 0">分销</span>
                <span class="price-text">￥{{ rowItem.record.proPriceMin }}</span>
                <span class="inventory-text" v-if="rowItem.record.proType===5">库存：{{ rowItem.record.stock }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="creatorName" slot-scope="rowItem">
        {{ rowItem.record.creatorName ? rowItem.record.creatorName : '--' }}
      </template>
      <span slot="action" slot-scope="rowItem">
        <template v-if="rowItem.record.proSource === 0 && rowItem.record.proJoinType !=22">
          <a @click="toEditor(rowItem.record.proId,rowItem.record.proType,rowItem.record.proSource)">编辑</a>
          <a-divider type="vertical"></a-divider>
        </template>
        <template v-if="rowItem.record.proSource === 1">
          <a @click="toEditor(rowItem.record.proId,rowItem.record.proType,rowItem.record.proSource)">查看</a>
          <a-divider type="vertical"></a-divider>
        </template>
        <template v-if="merchantType != 3">
          <a @click="toPoster(rowItem.record)">海报</a>
          <a-divider type="vertical"></a-divider>
          <a @click="onPreview(rowItem.record)">预览</a>
        </template>
        <template v-if="rowItem.record.proIsAudit == 0 && rowItem.record.proSource == 0">
          <a-divider type="vertical"></a-divider>
          <a @click="publicEvent(rowItem.record)">发布</a>
        </template>
        <template v-if="rowItem.record.proSource == 0">
          <a-divider type="vertical"></a-divider>
          <a @click="copyProduct(rowItem.record)">复制</a>
        </template>
      </span>
      <div :class="isFixed?'extra-pagination-fixed':'extra-pagination-name'" slot="extraPaginationName"
           v-if="selectedRowKeys.length > 0">
        <span>已选择 {{ selectedRowKeys.length }} 项</span>
        <a-button class="ml10" @click="updateProState(1)" v-if="pageType !== 1">上架</a-button>
        <a-button class="ml10" @click="updateProState(0)" v-if="pageType !== 0">下架</a-button>
        <a-button class="ml10" @click="showGroupDialogEvent">分组</a-button>
        <a-popconfirm
          :title="selectedRowKeys.length > 0 ? '是否要删除当前选择的商品？' : '请先选择要删除的商品！'"
          @confirm="deleteEvent()"
        >
          <a-button class="ml10" type="danger">删除</a-button>
        </a-popconfirm>
      </div>
    </search-page-view>

    <!-- 导出弹窗 -->
    <ExportTableData
      v-if="visiblePopup"
      :queryParams="queryParams"
      :isCustom="true"
      :exportReportType="0"
      :visiblePopup="visiblePopup"
      @childCloseDialog="closeDialog"
    ></ExportTableData>
    <!-- 分组弹窗 -->
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageDialogList"
      :itemNames="['search_groupName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadGroupPromise"
      :enableSearch="false"
      @close="showSelectedDialog=false"
      :columns="getGroupColumns()"
    >
      <a-form-item slot="search_groupName" style="margin-bottom: 10px">
        <a-input-search v-model="selectedQueryParams.groupName" placeholder="请输入分组名称" @search="onGroupSearch"/>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a v-if="rowItem.record.addDeleteStatus===1" class="font-color" @click="updateGroup(rowItem.record)">移除</a>
        <a v-else @click="updateGroup(rowItem.record)">加入</a>
      </template>
      <div slot="footer" class="btns-bottom">
        <a-button @click="showSelectedDialog=false">取消</a-button>
        <!--        <a-button type="primary" class="ml10" @click="onSelectedResult(rowItem.record)">确定</a-button>-->
      </div>
    </selected-product-dialog>
    <a-modal
      :visible="rackOffSwitch"
      @cancel="handleCancelRackOff"
      @ok="hancleSubmitRackOff"
      centered
      width="600px"
      title="设置"
    >
      <div style="display: flex">
        <div>百货类商品库存为0时：</div>
        <div style="margin-left: 20px">
          <a-radio-group v-model="offSwitch">
            <a-radio :value="1">自动下架</a-radio>
            <a-radio :value="2">不下架</a-radio>
          </a-radio-group>
          <div style="color: #999999">说明：此设置只对自有产品有效。</div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="categoryVisible"
      @cancel="handleCancelCategory"
      @ok="handleSubmitCategory"
      :confirmLoading="loading"
      centered
      width="600px"
      title="经营品类"
    >
      <a-table
        :pagination="false"
        :columns="categoryColumns()"
        :data-source="merchantTypeList"
        rowKey="categoryId"
        :rowSelection="rowSelection"
      >
        <template slot="status" slot-scope="text,record">
          <span v-if="record.state<3">{{
              record.state == 0 ? '未申请' : record.state == 1 ? '审核中' : '已申请'
            }}</span>
          <span v-else>
            <a-tooltip>
              <template slot="title">{{ auditMsg }}</template>
              <a style="color: red">申请失败</a>
            </a-tooltip>
          </span>
        </template>
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '../../utils/mixins/searchFormMixins'
import ExportTableData from '@/customComponents/exportTableData/exportTableData'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'ProductList',
  mixins: [searchForm],
  components: {
    ExportTableData, SelectedProductDialog
  },
  data() {
    return {
      visiblePopup: false,
      pageType: 1,
      searchItemList: [
        'search_proId',
        'search_proNo',
        'search_proName',
        'search_proType',
        'search_proSource',
        'search_sales_volume',
        'search_date'
      ],
      selectedDate: undefined,
      queryParams: {},
      selectedRowKeys: [],
      selectedStr: null,
      selectedQueryParams: {
        groupName: ''
      },
      showSelectedDialog: false,
      selectedGroupList: [],
      showGroupDialogCount: 0,
      isFixed: true,
      customPaginationTop: 0,
      rackOffSwitch: false,
      categoryVisible: false,
      offSwitch: 1,
      merchantTypeList: [],
      selectedCategoryRowKeys: [],
      selectedCategoryRows: [],
      loading: false,
      auditMsg: '',
      categoryList: [],
      sourceList: [],
      merchantType: 3//1经销商 2分销商 3供应商
    }
  },
  created() {
    this.queryParams.proStatus = 1
  },
  computed: {
    isSelected(groupId) {
      if (!this.selectedGroupList || this.selectedGroupList.length < 1) {
        return false
      }
      return this.selectedGroupList.includes(groupId)
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedCategoryRowKeys,
        hideDefaultSelections: true,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedCategoryRowKeys = selectedRowKeys
          this.selectedCategoryRows = selectedRows.filter(item => item.state == 0 || item.state == 3)
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.state == 1 || record.state == 2
          }
        })
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.customPaginationTop = this.$refs.pageList.$refs.table.$refs.customPaginationTop.offsetTop
    this.getLogUtils().logWithTag('customPaginationTop', this.customPaginationTop)
  },
  activated() {
    this.getCategoryList()
    this.getMerchantNewField()
    this.getSourceList()
  },
  methods: {
    getMerchantNewField() {
      this.getHttpServices().getUserService().post('/api/v2/merchant/getMerchantNewField/' + this.$store.getters.userInfo.merchantId, {})
        .then(res => {
          this.merchantType = res.merchantType
        }).catch(reason => this.getLogUtils().errorWithTag('getRolePermissions', reason))
    },
    getCategoryList() {
      this.categoryList = []
      this.getHttpServices().getUserService().post('api/v2/merchant/product/category/list', {})
        .then(res => {
          this.categoryList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getSourceList() {
      this.sourceList = []
      this.getHttpServices().getUserService().post('api/v2/merchant/product/source/list', {})
        .then(res => {
          this.sourceList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    showCategoryModal() {
      this.categoryVisible = true
      this.getMerchantTypeList()
    },
    handleCancelCategory() {
      this.categoryVisible = false
    },
    handleSubmitCategory() {
      if (this.selectedCategoryRows && this.selectedCategoryRows.length) {
        this.loading = true
        let operateCategoryIds = this.merchantTypeList.filter(item => item.state == 1 || item.state == 2).map((item) => {
          return item.categoryId
        }).join(',')
        let applyCategoryIds = this.selectedCategoryRows.map((item) => {
          return item.categoryId
        }).join(',')
        let params = {
          operateCategoryIds: operateCategoryIds,//原经营品类id集合
          applyCategoryIds: applyCategoryIds//新申请经营品类id集合
        }
        this.getHttpServices().getUserService().post('merchant/category/audit/save', params)
          .then(res => {
            this.$message.success('保存成功')
            this.handleCancelCategory()
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.loading = false)
      } else {
        this.$message.error('请添加品类')
      }
    },
    getMerchantTypeList() {
      this.merchantTypeList = []
      this.selectedCategoryRowKeys = []
      this.selectedCategoryRows = []
      this.getHttpServices().getUserService().post('merchant/category/audit/submit', {})
        .then(res => {
          this.merchantTypeList = res.saleCategoryList
          this.auditMsg = res.auditMsg
          this.selectedCategoryRowKeys = this.merchantTypeList.filter(item => item.state == 1 || item.state == 2).map((item) => {
            return item.categoryId
          })
          console.error('this.selectedCategoryRowKeys', this.selectedCategoryRowKeys)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    categoryColumns() {
      return [
        {
          title: '经营品类',
          dataIndex: 'categoryName'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        }
      ]
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop //变量windowHeight是可视区的高度
      // this.getLogUtils().logWithTag('scrollTop', scrollTop)
      this.isFixed = this.customPaginationTop > scrollTop ? true : false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.getLogUtils().logWithTag('selectedRowKeys', this.selectedRowKeys)
      this.selectedStr = this.selectedRowKeys.join(',')
    },
    getGoodsPromise(params) {
      params.proStatus = this.queryParams.proStatus
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    //搜索前，重置选中信息
    beforeSearchEvent() {
      this.selectedRowKeys = []
      this.selectedStr = ''
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.proCreateTimeStart = dateStrArr[0] //开始日期
      this.queryParams.proCreateTimeEnd = dateStrArr[1] //结束日期
    },
    onTypeChange(value) {
      this.selectedRowKeys = []
      this.queryParams.limitDto = {}
      this.queryParams.limitDto.pageNum = 1
      this.queryParams.proStatus = value.target.value
      this.$refs.pageList.refresh(true)
    },

    createProduct(e) {
      // this.getLogUtils().logWithTag('e.key==', e.key)
      this.toEditor(0, e.key, 0)
      // SkipOtherHelper.toCreateProduct(e.key)
    },
    hancleSubmitRackOff() {
    },
    handleCancelRackOff() {
      this.rackOffSwitch = false
    },
    onSetting() {
      // this.rackOffSwitch = true
      this.$message.warn('暂不支持此功能')
    },

    toPoster(record) {
      this.$router.push({
        name: 'PosterSet',
        query: {
          proId: record.proId,
          catalogId: record.proType,
          proSource: record.proSource
        }
      })
    },
    onPreview(record) {
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      const params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, record.proId, record.proType, 0, params)
    },
    //编辑
    toEditor(proId, catalogId, proSource) {
      // SkipOtherHelper.toEditProduct(proId,catalogId)
      let name = ''
      if (catalogId == 1) {
        name = 'TicketsBasicInfo'
      } else if (catalogId == 2) {
        name = 'HotelBasicInfo'
      } else if (catalogId == 3) {
        name = 'VisaBasicInfo'
      } else if (catalogId == 4) {
        name = 'ScenicHotelBasicInfo'
      } else if (catalogId == 5) {
        name = 'DepartmentBasicInfo'
      } else if (catalogId == 8) {
        name = 'PresellBasicInfo'
      } else if (catalogId == 75) {
        name = 'TravelBasicInfo'
      } else {
        name = 'TourBasicInfo'
      }
      let Logistics = this.$router.resolve({
        name,
        query: {
          proId: proId,
          catalogId: catalogId,
          proSource: proSource
        }
      })
      window.open(Logistics.href, '_blank')

    },
    //状态更新（上下架操作）
    updateProState(record) {
      if (this.selectedRowKeys.length == 0) {
        // this.$message.error("请勾选列表")
        return
      }
      const tips = record === 1 ? '上架成功' : '下架成功'
      const params = {
        proIds: this.selectedStr,
        status: record
      }
      this.operationRequest('public/ownProductsOnShelf', tips, params)
    },
    //发布事件
    publicEvent(record) {
      this.operationRequest('public/proRelease/' + record.proId, '发布成功')
    },
    // 复制产品
    copyProduct(record) {
      this.operationRequest('public/copyProGoods?proId=' + record.proId, '复制成功')
    },
    //删除事件
    deleteEvent() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选列表')
        return
      }
      const tips = '删除成功'
      const path = 'public/productDeleteBatch?proIds=' + this.selectedStr
      this.operationRequest(path, tips)
    },
    //通用操作请求
    operationRequest(path, tips, params) {
      this.getHttpServices()
        .getProService()
        .post(path, params)
        .then(res => {
          this.selectedRowKeys = []
          this.$message.success(tips)
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 导出
    exportEventPro() {
      this.getLogUtils().logWithTag('导出', this.queryParams)
      this.visiblePopup = true
    },
    // 关闭导出弹窗
    closeDialog() {
      this.visiblePopup = false
    },
    // 查看已生产报表
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    getColumns() {
      return [
        {
          title: '商品信息',
          dataIndex: 'info',
          scopedSlots: { customRender: 'info' },
          width: '45%'
        },
        {
          title: '收藏数',
          dataIndex: 'proFavoriteNum',
          align: 'center'
        },
        {
          title: '累计销量',
          dataIndex: 'proSales',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'proCreateTime'
        },
        {
          title: '创建人',
          dataIndex: 'creatorName',
          align: 'center',
          scopedSlots: { customRender: 'creatorName' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    showGroupDialogEvent() {
      this.selectedQueryParams.productIds = this.selectedRowKeys
      this.showSelectedDialog = true
      if (this.showGroupDialogCount > 0) {
        this.$refs.pageDialogList.refresh(true)
      }
      this.showGroupDialogCount++
    },
    loadGroupPromise(params) {
      this.getLogUtils().logWithTag('params+++++++++++++++++', params)
      return this.getHttpServices().getProService().post('proGroup/findProGroupProductList', params)
    },
    updateGroup(record) {
      const params = {
        groupId: record.groupId,
        groupPreset: record.groupPreset,
        operationType: record.addDeleteStatus !== 1,// 操作方式: true 为加入; false 为移除
        productIds: this.selectedRowKeys
      }
      let tips = record.addDeleteStatus !== 1 ? '添加成功' : '移除成功'
      this.getHttpServices().getProService().post('proGroup/product/group/add-batch', params)
        .then(res => {
          this.$message.success(tips)
          this.$refs.pageDialogList.refresh(false)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onGroupSearch() {
      this.$refs.pageDialogList.refresh(true)
    },
    onSelectedResult(record) {
      this.getLogUtils().logWithTag('==onSelectedResult==', record)
    },
    getGroupColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'groupId'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '商品数量',
          dataIndex: 'proNum'
        },
        {
          title: '类型',
          dataIndex: 'groupStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.infoMain {
  position: relative;

  .infoText {
    position: absolute;
    bottom: 22px;
    left: 30px;
    height: 50px;
    width: 330px;
  }
}

.item-proInfo {
  display: flex;

  .content-right {
    flex: 1;
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .pro_title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
    }

    .bottom-box {
      .pro_id {
        font-size: 12px;
        color: #8f8f8f;
      }

      .pro_tag {
        display: flex;
        align-items: center;

        .tag {
          height: 20px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 10px;
          color: #fff;
          border-radius: 2px;
          background-color: rgba(115, 209, 61, 1);
          margin-right: 8px;
        }

        .price-text {
          color: #ff7700;
          font-size: 12px;
        }

        .inventory-text {
          margin-left: 8px;
          font-size: 12px;
        }
      }
    }
  }
}

.btns-bottom {
  margin-top: 15px;
  text-align: right;
}

.font-color {
  color: red;
}

.extra-pagination-fixed {
  position: fixed;
  left: 275px;
  bottom: 0px;
  z-index: 100;
  background: #FFFFFF;
  padding: 5px 24px;
  border-radius: 5px;
}
</style>
<style lang="less">
.infoMain {
  .ant-table-tbody > tr > td {
    padding: 8px 8px;
  }
}
</style>
